import { Button } from "primereact/button";
import { FaTrash, FaPen } from "react-icons/fa";
const ActionBody = ({
  data,
  toggleEdit = () => {},
  toggleDelete = () => {},
  toggleInfo = () => {},
  editB = true,
  deleteB = true,
  infoB = false,
  containerClassName = "",
}) => {
  return (
    <>
      <div className={`action-body ${containerClassName}`.trim()} id="action-body">
        {infoB && (
          <Button
            type="button"
            icon="pi pi-info-circle"
            className="action-body-btn action-body-btn-aqua"
            tooltip="Información"
            tooltipOptions={{ position: "top" }}
            onClick={() => toggleInfo(data)}
            aria-label="información"
          />
        )}
        {editB && (
          <Button
            type="button"
            icon={<FaPen size={"0.9rem"}/>}
            className="action-body-btn action-body-btn-blue"
            tooltip="Editar"
            tooltipOptions={{ position: "top" }}
            onClick={() => toggleEdit(data)}
            aria-label="editar"
          />
        )}
        {deleteB && (
          <Button
            type="button"
            icon={<FaTrash size={"1rem"}/>}
            className="action-body-btn action-body-btn-red"
            tooltip="Eliminar"
            tooltipOptions={{ position: "top" }}
            onClick={() => toggleDelete(data)}
            aria-label="eliminar"
          />
        )}
      </div>
    </>
  );
};

export default ActionBody;
